import * as React from 'react';
import * as styles from './styles.css';

export interface ISummaryProps {
  sortFilter?: React.ReactNode;
  total: React.ReactNode;
}

export function Summary({ total, sortFilter }: ISummaryProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['total']}>{total}</div>
      {sortFilter && <div>{sortFilter}</div>}
    </div>
  );
}
